<template>
    <!-- contents -->
    <div id="contents">
    	<div class="contents_wrap">
            <!-- //breadcrumbs -->
            <h2 class="pg_title">Service Bulletin parts Search </h2>

            <!-- 결과 영역 -->
            <div class="result_wrap">
                <p class="refine"><em>{{$t('TITLE.SEARCH.RESULT.FOR')}}</em> '{{partsCode}}'</p>
                <!-- 1. Quick Downloads -->
                <section data-type="quick" class="active"><!-- 활성화시 active 클래스 -->
                    <div class="result_title">
                        <em>{{$t('TITLE.SEARCH.QUICK.DOWNLOAD')}}</em>
                    </div>

                    <div class="result_con">
                        <!-- Quick Downloads - Tablet/Mobile -->
                        <!-- div v-if="quickDownloads.length > 0" class="table_modul tabmobile_only"-->
                        <div v-if="quickDownloads.length > 0" class="table_modul">
                            <table class="data_table_ty2">
                                <colgroup>
                                    <col width="30%">
                                    <col width="70%">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th >Parts Code</th>
                                        <th >Title</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sub in selParts" :key="sub.ID">
                                        <td>{{sub.PARTS_CODE}}</td>
                                        <td >
                                            <a href="JavaScript:" @click="viewContents(sub.KNOWLEDGE_ID)">
                                                <em class="txt_point">{{sub.KNOWLEDGE_TITLE}}</em>
                                            </a>

                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <ul v-if="qcdnTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                        
                    </div>
                </section><!-- 1. End of Quick Downloads -->
            </div>
        </div> <!-- contents_wrap -->
    </div> <!-- contents -->
</template>

<script>
import Vue              from 'vue';
import axios            from 'axios';
import store            from '@/vuex/store';
import qs               from 'query-string';
import _                from 'lodash';
import $                from 'jquery';
import moment           from 'moment';
import { mapGetters }   from 'vuex';
import { SDLUtil }      from '@/utils';
import AttachFilePopupParts  from './AttachFilePopupParts';
import InnorixDownload  from '~c/InnorixDownload';
import ExpToastGrid     from '~c/ToastGrid';

export default {
    name: 'GspnPartsSearch',
    props: {
//        params: {}
    },
    components: {
        'toast-grid'        : ExpToastGrid,
        'innorix-download'  : InnorixDownload
    },

    computed: {
        ...mapGetters({
            popupParams: 'getPopupParams'
        })
    },
    data() {
    	//let parts = this.params.partsCode;
    	//alert(" parts:"+parts);
        return {
            isLoaded: 0,
            viewName: '444',
            params: {},
            startNum: 0,    // 시작순서
            pageSize: 10,    // 페이지당 갯수
            serverSize: 50, // 서버 페이지당 갯수
            sortBy: 'regdate',
            relResearch: 'N',
            placeHolder: SDLUtil.getMsgProp('FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH'),
            searchMode: '0',
            modelCode: '',
            partsCode: '',
            //selModelCd: '',
            //selModels: [],
            selParts: [],
            moreKey: '', // contcoll ID
            autoCompletes: [],
            //recentModels: [],
            cursorIndex: -1,
//            relatedSearchWords: [],
//            columns: [],
            quickDownloads: [],

            sympCode: '',
            sympDesc: '',
            sympTypeCode: '',

            toggle1: true,

            qcdnMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),
            qcdnPage : 1,
            qcdnAttachFiles: [],

            qcdnTotalCount: 0, // Quick Downloads 전체건수
            resultCount: 0,

            placeHolder: SDLUtil.getMsgProp('FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH'),
            currentPage: 1,
            perPage: 3000, // parseInt(localStorage.getItem('listRows') || 10),
            gridId : 'gridExpModel',
            gridKey: 0,
            gridData :  [],
            /*
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'),
                    name: 'MODEL_CD',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EXPVIEW.PROD.DESC'),
                    name: 'PROD_DESC',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EXPVIEW.PLANT'),
                    name: 'PLANT',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('TITLE.PRODUCT.INFO.EXPLODED.VIEW'),
                    name: 'VIEW_CNT',
                    align: 'center',
                    width: '200',
                    sortable: true
                }
            ],    
            */
            options: {
                scrollY: false,
                scrollX: false,
//                minBodyHeight: 80,
//                bodyHeight: 318,
                rowHeight: 25,
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 10, //parseInt(localStorage.getItem('listRows') || 10),
            },

            serviceType: 'common'
        };
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            userCorpCd: 'getCorpCd'
        }),
        getLoginNo()            { return this.loginNo || ''; },
        getUserCorpCd()         { return this.userCorpCd || ''; }
    },
    methods: {
    	
        initReset() {
        	
            //let popupParams = store.getters.getPopupParams || {};
            //console.log("==============");
            //console.log(popupParams);
            //console.log("==============");
            
            this.dtcmPage    = 1;
            this.qcdnTotalCount = -1;
//            this.relatedSearchWords = [];
            this.quickDownloads  = [];
            this.qcdnLoadCount = 0;
            this.qcdnAttachFiles = [];
        },

        getDataFromServer(mode, initMode) {
//            $('.quick_downs').show();
            SDLUtil.showLoadingBar(true);
            let url = `${SDLUtil.API_URL}/basis/search/getServiceBulletinByParts.skp`;
            const param = this.getSearchParam();
            param.initMode = (initMode) ? 'Y' : '';
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
//                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    console.log('LocalDB.resp.data ===> ', resp.data);
                    this.selParts = resp.data;
                    this.quickDownloads = resp.data;
                    this.qcdnTotalCount = this.quickDownloads.length;
                    //this.qcdnTotalCount = qcdnLoadCount;
                    //this.setColumnHeader(resp.data, this.qcdnPage);
//                    $('.quick_downs').hide();
                    SDLUtil.showLoadingBar(false);                        
                })
                .catch(err => {
                    console.log('Error.mode ===> ', mode, err);
                    SDLUtil.errorAlert(err);
                });
        },
        viewAttachFiles(event, row) {
            $(event.target).parent('a').parent('td').parent('tr').parent('tbody').children('tr').removeClass('active');
            $(event.target).parent('a').parent('td').parent('tr').addClass('active');
            const param = { modelCode: row.BMODEL_ID };
            const url = `${SDLUtil.API_URL}/basis/search/getBomPdfFilesByModel.skp`;
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
//                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    this.qcdnAttachFiles = resp.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        async initFilesLoad(knowId) {
            SDLUtil.showLoadingBar(true);
            if (SDLUtil.isNull(knowId)) {
                SDLUtil.showLoadingBar(false);
                SDLUtil.alert({
                    title: "TITLE.GLOBAL.POPUP.ALERT",  // Alert
                    msg: "MESSAGE.FILE.NOSELECTFILE",   // No file is choosed.
                    okLabel: "BUTTON.GLOBAL.CLOSE",     // Close
                    onOkEvt : () => { this.$emit('close'); }
                });
            } else {
                return await fetchAttachList({ BOARD_ID: knowId });
            }
        },
        viewContents(knowledgeId) {
            //let knowledgeId = knowledgeId;
            let headerNm = 'Service Bulletin';
            const param = {knowledgeId: knowledgeId};
            const url = `${SDLUtil.API_URL}/basis/search/getKnowledgeId.skp`;
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                	console.log('resp.data ==> ', resp.data);
                    SDLUtil.show(
                    		AttachFilePopupParts, {
                            title: headerNm,
                            knowledgeInfos: resp.data,
                        }, {  // component params
                            height: 'auto'
                        }   // dialog params
                    );
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },

        getSearchParam() {
            const param = { 
                //  keyword    : this.modelCode
                  partsCode    : this.partsCode
                , corpNo     : $('#selectRhqSubCd').val()
                , page       : this.qcdnPage // start Page
                , perPage    : this.pageSize //
                , searchKind : 'C' // 고정
                , viewName   : '555'
//                , relResearch   : this.relResearch
            };
            return param;
        },
        onSearch(page) {
			/*
            if (this.modelCode.trim().length < 3) {
                SDLUtil.alert('MESSAGE.SEARCH.INPUT.KWORD');
                this.$refs.kword.focus();
                return;
            }
			*/
            this.qcdnPage = 1;
            this.searchMode = '0';

            SDLUtil.showLoadingBar(true);
//            this.isLoaded = 0;
            this.initReset();

            // 일단, 최근 검색어 등록
//            this.saveRecentModel();

            // 이단, DB 검색결과 가져오기
            this.getDataFromServer(1, true); // Local DB

            // 삼단, 검색엔진 조회
//            this.relResearch  = 'N';
//            this.sympCode     = '';
//            this.sympDesc     = '';
//            this.sympTypeCode = '';
//            this.getDataFromServer(2, initMode); // Search Engine

            return;
        },

    }, // methods
    watch: { // keyword를 clearable로 지웠을 때...
        // Change of date unit
    },
    created() {

//      this.params = this.$route.query; // 검색팝업에서 받은 params
//console.log('=======================');
//console.log(store.getters);
        this.params = store.getters.getPopupParams || {};
        this.modelCode = this.params.modelCode;
        this.partsCode = this.params.modelCode;
        this.viewName  = this.params.viewName;
        //console.log(params);  ==> 왜 에러가 나지 ? 
        //alert(" this.params.partsCode:"+this.params.partsCode);
        //alert(" this.partsCode:"+this.partsCode);
        //alert(" this.modelCode:"+this.params.modelCode);
        //alert(" this.modelCode:"+this.params.modelcode);
        //alert(" this.partscode:"+this.params.partscode);
        //alert(" this.params.userId:"+this.params.userId);
    },
    mounted() {
        console.log('Mount.this.params ==> ', this.params);
        this.onSearch(1);
        
        /*
        // 조회하면서 들어온다.
        if (this.viewName == 'MC') this.onSearch(1); // ModelCode Search
        //else if (this.viewName == 'EM') this.onSearchExp(1); // Exploded Model Search
        else if (this.viewName == 'KN') { // KnowledgeDetail Info
            this.$router.push({
                name: 'GSPNConKnowledgeDetail',
                query: { boardId: this.params.boardId, knowledgeId: this.params.knowledgeId, type: this.viewName }
//                       , userId: this.params.userId, companyCode: this.params.companyCode }
            });
        } else alert('Wrong access.');
        */
        return;
    },
    beforeDestroy() {
//        EventBus.$off('search-snb-reload');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/gspnCon/CommonConnectParts.vue